import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconViewTracking = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.69045 19.5795H4.72371C3.73819 19.5795 2.79303 19.1879 2.09617 18.4911C1.3993 17.7942 1.00781 16.8491 1.00781 15.8636V12.9745C1.00781 9.79859 2.2694 6.75288 4.51505 4.50724C6.7607 2.26159 9.80643 1 12.9823 1H14.0135C14.9989 1 15.9442 1.39149 16.641 2.08836C17.3378 2.78523 17.7294 3.73037 17.7294 4.71589V9.76942",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 13.1324C1 8.33889 6.10939 12.2033 9.10994 9.19345C12.1105 6.18363 8.27386 1 13.0581 1",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9998 17.0523C15.1625 17.0523 16.1051 16.1687 16.1051 15.0787C16.1051 13.9886 15.1625 13.105 13.9998 13.105C12.8371 13.105 11.8945 13.9886 11.8945 15.0787C11.8945 16.1687 12.8371 17.0523 13.9998 17.0523Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 14.9474C12.045 9.68174 15.955 9.68668 19 14.9474",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 15.2104C15.955 20.4761 12.045 20.4711 9 15.2104",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconViewTracking;
